<template>
    <section> 
        <div class="row" v-if="avaliacoes && avaliacoes.length > 0">
            <div class="col s12">
                <div class="card-panel" style="border: 2px solid #00b8d4">
                    <div class="row">
                        <h5 class="col s12">
                            Resultado das Avaliações
                        </h5>
                    </div>
                    <div class="row">
                        <div class="col s12">
                            <table class="responsive-table striped centered">
                                <thead>
                                <tr>
                                    <th></th>
                                    <th>Pontuação</th>
                                    <th>Justificativa</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(avaliacao, av_i) in avaliacoes"
                                    :key="av_i">
                                    <template v-if='avaliacao.invalido'> 
										<td><span class="title" style="font-weight: bold;color:gray">Avaliador {{ av_i + 1 }} *</span></td>
										<td><span style="color:gray">--</span></td>
										<td><span style="color:gray">--</span></td>     
									</template>
									<template v-else> 
										<td><span class="title" style="font-weight: bold">Avaliador {{ av_i + 1 }}</span></td>
										<td><span>{{ retornaItemAvaliacaoPontos(avaliacao) }} ponto(s)</span></td>
										<td><span>{{ retornaItemAvaliacaoJustificativa(avaliacao) }}</span></td>
									</template>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "resultado_avaliacoes_itens_acao",
    props: {
        avaliacoes: {
            type: Array|null,
            default: null
        },
        itemDescricao: {
            required: false,
            type: String|null,
            default: null
        },
        campoReferenteNaInscricao: {
            required: false,
            type: String|null,
            default: null
        }
    },
    methods: {
        retornaItemAvaliacao(avaliacao){
            if(!this.itemDescricao && !this.campoReferenteNaInscricao)
                return null;

            return _.find(avaliacao.itens_da_acao, (item) => {
                if (this.campoReferenteNaInscricao)
                    return _.trim(item.campo_referente_na_inscricao) == _.trim(this.campoReferenteNaInscricao)

                return _.trim(item.nome) == _.trim(this.itemDescricao);
            });
        },

        retornaItemAvaliacaoPontos(avaliacao){
            const item = this.retornaItemAvaliacao(avaliacao)

            return !item ? 'N/a' : item.nota
        },

        retornaItemAvaliacaoJustificativa(avaliacao){
            const item = this.retornaItemAvaliacao(avaliacao)

            return !item ? 'N/a' : (!item.justificativa ? 'N/a' : item.justificativa)
        },
    },
}
</script>

<style scoped>

</style>